import Slider from 'react-slick';

const DEFAULT_SETTINGS = {
    dots: true,
    infinite: true,
    autoplaySpeed: 4000,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    swipe: true,
};

export default function Carousel({ settings = DEFAULT_SETTINGS, ...props }) {
    return <Slider {...settings}>{props.children}</Slider>;
}
